export enum Image {
  USER_LOGGED = 'User Logged',
}
